import React from 'react'

interface IProps {
    categories: Array<Record<string, any>>
    selectedCategory: string | string[]
    onChange: (value: string) => void;
}
function isArraysEqual(firstArray: string[], secondArray: string[]): boolean {
    return firstArray.toString() === secondArray.toString();
}

export const NotFill = ({ categories, selectedCategory, onChange }: IProps): JSX.Element => {
    return (
        <div className="row g-4 w-100 px-4 my-2">
            {categories.map((category, index) => (
                <div
                    key={category.name}
                    className={`${index === categories.length - 1 && categories.length % 2 !== 0 ? "col-12"
                        : "col-6"}`}
                >
                    <div
                        className={`d-flex flex-column align-items-center rounded-4 p-2 cursor-pointer h-100 justify-content-center border border-1 border-gray-200
                        ${'statuses' in category ? isArraysEqual(category?.statuses, selectedCategory as string[]) ? "bg-bso-semi-back" : "bg-light-secondary" : selectedCategory === category.value ? "bg-bso-semi-back" : "bg-light-secondary"}  position-relative`}
                        onClick={() => {
                            onChange('statuses' in category ? category.statuses : category.value);
                        }}
                    >
                        {/* {index === categories.length - 1 && categories.length % 2 !== 0 &&
                        (<span className="position-absolute top-1 start-100 translate-middle badge badge-circle badge-danger">
                            3
                        </span>)} */}
                        <div className="d-flex align-items-center w-100 lh-sm">
                            <div className='lh-1'>
                                <div
                                    className={`text-end fs-6 text-dark text-uppercase my-2
                                ${selectedCategory === category.value ? "fw-bold" : "fw-semibold"} lh-1`}
                                >
                                    {category.name}
                                </div>
                                {category.description && <div className={`text-end d-block mb-2 fs-8 ${'statuses' in category && isArraysEqual(category?.statuses, selectedCategory as string[]) ? "text-dark" : "text-gray-600"}`}>{category.description}</div>}
                            </div>
                            {/* Бейдж с количеством уведомлений */}
                            {/* <span className="badge bg-primary rounded-pill">
                        {category.items.reduce((total, item) => total + (notifications[item as keyof typeof notifications] || 0), 0)}
                    </span> */}
                        </div>
                    </div>
                </div>
            ))
            }
        </div >


    )
}
